
export default {
  data: function () {
    return {};
  },
};
